<template>
  <div id="nav" v-if="this.isDevelopmentMode">
    <router-link to="/">SchedaView</router-link> | 
     <router-link :to="{ name:'Scheda', params: { category: 'Zaini+tempo+libero', codListino: 'M10572' } }">Art. M10572</router-link> | 
    <router-link :to="{ name:'Scheda', params: { category: 'Pantaloncini+allenamento', codListino: 'C19400' } }">Art.C19400</router-link> | 
    <router-link :to="{ name:'Scheda', params: { category: 'T-Shirt+uomo', codListino: 'TSO150' } }">Art.TSO150</router-link> | 
    <router-link :to="{ name:'Scheda', params: { category: 'Borracce', codListino: 'MO9350' } }">Art.MO9350</router-link> | 
    <router-link :to="{ name:'Scheda', params: { category: 'Braccialetti+in+silicone', codListino: 'ZG20200' } }">Art.ZG20200 (FC)</router-link> | 
    <router-link :to="{ name:'CarrelloPers' }">CarrelloPers</router-link> | 
    <router-link :to="{ name:'OrdineCompletato', params: { n:'0', ord: '123' } }">Ordine OK</router-link>
  </div>
  <router-view />
</template>

<script>
export default {

  data() {
    return {
      isDevelopmentMode: process.env.NODE_ENV !== 'production',
    }
  },
  mounted() {
  //   this.$store.dispatch('getLoggedUser')
  //     .then(res => {
  //       console.log(res);
  //     })
  //     .catch(error => {
  //         this.$router.push({
  //             name: 'ErrorDisplay',
  //             params: { error: error }
  //         })
  //     });
  }
}
</script>

<style>
#app-scheda {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  
  /* text-align: center; */
  /* color: #2c3e50; */
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.withMarginTop{
  margin-top:15px;
}

.withMarginBottom{
  margin-bottom:15px;
}

.withMarginTopButton{
  margin-top:15px;
  margin-bottom:15px;
}

input:focus,
input:focus-visible,
input:active:focus,
button:focus,
button:focus-visible,
button:active:focus{
    outline: none !important;
} 

.msgTopSuccess {
  background: url('./assets/css/images/success.png') no-repeat 10px center;
  color: black !important;
}

.stdMessage {
  max-width: none !important;
  border: none !important;
  border-bottom: 1px solid lightgrey !important;
  background-color: transparent !important;
  padding: 17px 20px 17px 50px !important;
  border-radius: 0px !important;
  margin-bottom: 18px;
  display:block;
}

.fastLinkInfo a {
  color:#028bff;
  cursor:pointer;
}

.vcenter {
  display: inline-block;
  vertical-align: middle;
  float: none;
}

/*vertical align using flex*/
/*apply this class to row div container*/
.vertical-align-row {
  display: flex;
  flex-direction: row;
}

.vertical-align-col-bottom {
  display: flex;
  align-items: flex-end;     /* Align the flex-items vertically */
  /*justify-content: center; / * Optional, to align inner flex-items
                                horizontally within the column  */
}

.vertical-align-col-center {
  display: flex;
  align-items: center;     /* Align the flex-items vertically */
  /*justify-content: center; / * Optional, to align inner flex-items
                                horizontally within the column  */
}

.flex-container {
  display: flex;
}

.flex-container-column {
  display: flex;
  flex-direction: column;
}

.flex-item-center-x {
  align-items: center;
}

.flex-item-center-y {
  justify-content: center;
}

.btnPrimary {
  font-size:15px !important;
  font-weight:bold !important;
  background-color:#004F87 !important;
  border:none !important;
  height:45px !important;
  width: 240px !important;
  padding:10px !important;
}
.btnPrimary:hover{
  text-decoration: none !important;
}

.btnSecondary {
  font-size:15px !important;
  font-weight:bold !important;
  background-color:#EEEEEE !important;
  color:#000000 !important;
  border:none !important;
  height:45px !important;
  padding:10px !important;
}

.btnSecondarySmall{
  font-size:13px !important;
  font-weight:bold !important;
  background-color:#EEEEEE !important;
  color:#000000 !important;
  border:none !important;
  height:35px !important;
  padding:10px !important;
}

.spin-faster{
  -webkit-animation: fa-spin 1s infinite linear !important;
  animation: fa-spin 1s infinite linear !important;
}

</style>
